module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_61.1526598a.png";